import { PlatformVariants } from "./PlatformVariants";

export const PlatformsSets = Object.freeze({

    CONFIG_1: [
        { platforms: [PlatformVariants.STANDARD], chance: 0.6 },
        { platforms: [PlatformVariants.STANDARD, PlatformVariants.BLANK], chance: 0.2 },
        { platforms: [PlatformVariants.BREAKING], chance: 0.1 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK], chance: 0.1 },
    ],

    CONFIG_2: [
        { platforms: [PlatformVariants.STANDARD], chance: 0.2 },
        { platforms: [PlatformVariants.STANDARD, PlatformVariants.BLANK], chance: 0.2 },
        { platforms: [PlatformVariants.STANDARD, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.1 },
        { platforms: [PlatformVariants.BREAKING], chance: 0.1 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK], chance: 0.2 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.2 },
    ],

    CONFIG_3: [
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK], chance: 0.5 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.3 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.2 },
    ],

    CONFIG_4: [
        { platforms: [PlatformVariants.STANDARD, PlatformVariants.BLANK], chance: 0.4 },
        { platforms: [PlatformVariants.STANDARD, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.3 },
        { platforms: [PlatformVariants.SAW, PlatformVariants.BLANK, PlatformVariants.STANDARD], chance: 0.3 },
    ],

    CONFIG_5: [
        { platforms: [PlatformVariants.STANDARD, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.2 },
        { platforms: [PlatformVariants.BREAKING], chance: 0.2 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK], chance: 0.2 },
        { platforms: [PlatformVariants.DYNAMIC, PlatformVariants.BLANK, PlatformVariants.BLANK], chance: 0.2 },
        { platforms: [PlatformVariants.SAW, PlatformVariants.BLANK, PlatformVariants.STANDARD], chance: 0.2 },
    ],

});